import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzRateModule } from 'ng-zorro-antd';
import { AtxRateComponent } from './components/atx-rate.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        NzRateModule,
    ],
    declarations: [
        AtxRateComponent,
    ],
    exports: [
        AtxRateComponent,
    ],
})

export class AtxRateModule {}
